import {
  getQwParams,
  qWLogin,
  loginToQiYu,
  queryLeadsBySessionId,
} from '@/api/qw';
import { getUrlParams, getParseQuery } from '@/utils/tools';

export const wxInit = () => {
  return new Promise((resolve, reject) => {
    const params = getUrlParams();
  
    if (params.code && params.code !== window.sessionStorage.getItem('_code')) {
      // 业务流程
      resolve({ code: params.code });
      window.sessionStorage.setItem('_code', params.code); // 缓存本次的code值
    } else {
      const appid = 'wwe0deca240d17c0a2';
      const local = window.location.href;
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
        local
      )}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
      reject();
    }
  })
}

/**
 * sideBarType 侧边栏类型，后端会关联到对应的应用上去
 */
export const wxLogin = (code: string, sideBarType: string = '') => {
  return new Promise(async(resolve, reject) => {
    /** 微信端登录 */
    const [toeknErr, tokenRes] = await qWLogin({ code, sideBarType });
    if (toeknErr) {
      reject({ errMsg: '获取token信息失败', });
      throw new Error('获取token信息失败');
    }
  
    // 适配客途的格式
    window.localStorage.setItem('Admin-Token', JSON.stringify({
      data: tokenRes.data.adminToken,
    }));
  
    const [err, res] = await getQwParams({ url: encodeURIComponent(window.location.href), sideBarType });
  
    if (err) {
      reject({ errMsg: '获取微信鉴权信息失败', })
      throw new Error('获取微信鉴权信息失败');
    }

    const data = res?.data;

    /** 微信配置 */
    (window as any).wx.ready(function() {
      (window as any).wx.agentConfig({
        corpid: data?.appId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: data?.agentId, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: data?.timestamp, // 必填，生成签名的时间戳
        nonceStr: data?.nonceStr, // 必填，生成签名的随机串
        signature: data?.agentSignature,// 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: ['getContext', 'getCurExternalContact', 'getCurExternalChat', 'openDefaultBrowser', 'setClipboardData'], //必填，传入需要使用的接口名称
        success: function() {
          resolve([]);
        },
        fail: function(res: any) {
          if(res.errMsg.indexOf('function not exist') > -1){
            alert('版本过低请升级')
          }
          reject({ errMsg: 'wx agentConfig error: ' + res.errMsg });
        }
      });
    });

    (window as any).wx.error(function(res: any) {
      reject({ errMsg: 'wx config error: ' + res.errMsg });
    });

    (window as any).wx.config({
      beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data?.appId, // 必填，企业微信的corpID，必须是本企业的corpID，不允许跨企业使用
      timestamp: data?.timestamp, // 必填，生成签名的时间戳
      nonceStr: data?.nonceStr, // 必填，生成签名的随机串
      signature: data?.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
      jsApiList: ['agentConfig'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
    });
  })
}

export const qyInit = () => {
  const params = getUrlParams();
  const sessionId = params.id;

  return new Promise((resolve, reject) => {
    const obj = getParseQuery(window.location.href);

    loginToQiYu(obj).then(([err, res]) => {
      if (err) { reject([{ errMsg: '七鱼登录失败', }]); return; }

      window.localStorage.setItem('Admin-Token', JSON.stringify({
        data: res.data?.adminToken || '',
      }));

      queryLeadsBySessionId({ sessionId }).then(([qErr, qRes]) => {
        if (qErr) { reject([{ errMsg: '获取线索Id失败', }]); return; }

        resolve([null, { data: qRes.data }]);
      });
    });
  });
}
